/* スムーズスクロール
------------------------------------------ */
document.querySelectorAll('.smoothScroll').forEach((el) => {
  el.addEventListener('click', (e) => {
    const href = el.getAttribute('href') || '';
    if (!href.startsWith('#')) return;              // 外部リンク等はスルー
    const targetElement = document.getElementById(href.slice(1));
    if (!targetElement) return;                     // 対象が無い時は何もしない

    e.preventDefault();
    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset || document.documentElement.scrollTop || 0;
    const gap = 0;
    const target = rect + offset - gap;
    window.scrollTo({
      top: target,
      behavior: 'smooth',
    });
  });
});


/* ドロップダウンメニュー（jQuery）*/
$(function () {
  $('.has_child,.children-menu').hover(
    function () {
      $('.has_child').addClass('active');
      $('#active').addClass('active');
    },
    function () {
      $('.has_child').removeClass('active');
      $('#active').removeClass('active');
    }
  );
});


/* 黒背景の時はヘッダーナビの色を白にする */
const gnavs      = document.querySelectorAll('.global_nav');
const hamburgers = document.querySelectorAll('.hamburger');
const consulBtn  = document.querySelectorAll('.sp_consul__btn');
const blackBgs   = document.querySelectorAll('.black_bg');
const headerEl   = document.querySelector('header');

if (blackBgs.length && 'IntersectionObserver' in window) {
  const visibleSet = new Set();

  const applyClasses = () => {
    const on = visibleSet.size > 0;
    gnavs.forEach(el => el.classList.toggle('white', on));
    hamburgers.forEach(el => el.classList.toggle('white', on));
    consulBtn.forEach(el => el.classList.toggle('white', on));
  };

  const buildObserver = () => {
    const headerH = headerEl ? headerEl.offsetHeight : 64;
    const options = {
      root: null,
      rootMargin: `0px 0px -${window.innerHeight - headerH}px 0px`,
      threshold: 0,
    };

    if (window.__blackBgObserver) window.__blackBgObserver.disconnect();

    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visibleSet.add(entry.target);
        } else {
          visibleSet.delete(entry.target);
        }
      });
      applyClasses();
    }, options);

    blackBgs.forEach(el => obs.observe(el));
    window.__blackBgObserver = obs;
  };

  buildObserver();
  window.addEventListener('resize', buildObserver);
  applyClasses();
}


/* ハンバーガーメニュー */
(function(){
  const body     = document.body;
  const btn      = document.querySelector('.hamburger');
  const nav      = document.getElementById('globalNav');
  const backdrop = document.querySelector('.nav-backdrop');

  // 必須要素が無いページでは何もしない（落ち防止）
  if (!btn || !nav) return;

  const open = () => {
    body.classList.add('is-menu-open');
    btn.classList.add('is-active');
    btn.setAttribute('aria-expanded', 'true');
    lockScroll(true);
  };
  const close = () => {
    body.classList.remove('is-menu-open');
    btn.classList.remove('is-active');
    btn.setAttribute('aria-expanded', 'false');
    lockScroll(false);
    if (nav) {
      nav.querySelectorAll('.children-menu.is-open').forEach(el => el.classList.remove('is-open'));
    }
  };
  const toggle = () => (body.classList.contains('is-menu-open') ? close() : open());

  // スクロール固定（iOS対応の簡易版）
  let scrollTop = 0;
  function lockScroll(enable){
    if(enable){
      scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      body.style.position = 'fixed';
      body.style.top = `-${scrollTop}px`;
      body.style.left = '0';
      body.style.right = '0';
    }else{
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      window.scrollTo(0, scrollTop);
    }
  }

  btn.addEventListener('click', toggle);
  if (backdrop) backdrop.addEventListener('click', close);
  window.addEventListener('keydown', (e)=>{ if(e.key === 'Escape') close(); });

  // 子メニュー（SERVICEなど）をタップで展開
//   nav.addEventListener('click', (e)=>{
//     const a = e.target.closest('a.has_child');
//     if(!a) return;

//     if (window.matchMedia('(max-width:1031px)').matches){
//       e.preventDefault();
//       a.classList.toggle('active');
//       const child = a.parentElement.querySelector('.children-menu');
//       if(child) child.classList.toggle('is-open');
//     }
//   });


  // リンク押したら閉じる（同一ページ内アンカーも想定）
  nav.querySelectorAll('a:not(.has_child)').forEach(link=>{
    link.addEventListener('click', ()=> close());
  });

  // リサイズ時：PC幅に戻ったら強制クローズ
  window.addEventListener('resize', ()=>{
    if(!window.matchMedia('(max-width:1031px)').matches) close();
  });
})();
